import { AttachmentResponseDto } from '@issuemanager/api-client';
import { FileList, ViewLabelValue } from '@issuemanager/apps/client/components';
import { AttachmentType } from '@issuemanager/constants';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  attachments: AttachmentResponseDto[];
};

export function AttachmentsList(props: Props) {
  const { t } = useTranslation('action');

  const { attachments, approvalAttachments, declinationAttachments } = useMemo(
    () =>
      props.attachments.reduce(
        (acc, curr) => {
          switch (curr.attachmentType) {
            case AttachmentType.ATTACHMENT:
              acc.attachments.push(curr);
              break;
            case AttachmentType.APPROVAL:
              acc.approvalAttachments.push(curr);
              break;
            case AttachmentType.DECLINATION:
              acc.declinationAttachments.push(curr);
              break;
          }
          return acc;
        },
        {
          attachments: [] as AttachmentResponseDto[],
          approvalAttachments: [] as AttachmentResponseDto[],
          declinationAttachments: [] as AttachmentResponseDto[],
        },
      ),
    [props.attachments],
  );

  return (
    <>
      <ViewLabelValue
        label={t('view.details.attachments')}
        value={<FileList files={attachments} showVerticalDividers />}
        testId='attachments'
      />
      {Boolean(approvalAttachments.length) && (
        <ViewLabelValue
          label={t('view.details.approvalAttachments')}
          value={<FileList files={approvalAttachments} showVerticalDividers />}
          testId='approvalAttachments'
        />
      )}
      {Boolean(declinationAttachments.length) && (
        <ViewLabelValue
          label={t('view.details.declinationAttachments')}
          value={
            <FileList files={declinationAttachments} showVerticalDividers />
          }
          testId='declinationAttachments'
        />
      )}
    </>
  );
}
